import { useCallback, useEffect, useState } from "react";

const useImageErrorFallback = defaultImage => {
  const [el, setEl] = useState(null);

  const handleError = useCallback(e => {
    e.target.src = defaultImage;

    /**
     * The following lines of code fix a bug on Safari in which the Avatar
     * image is not automatically repainted after we update the src attribute.
     *
     * To force a repaint, we update a set of styles that webkit recognizes
     * as sufficient to re-render the element.
     *
     * Source: http://thenewcode.com/1024/Forcing-a-Webkit-Repaint
     */

    e.target.style.display = "none";
    // eslint-disable-next-line no-unused-expressions
    e.target.offsetHeight;
    e.target.style.display = "block";

    e.target.removeEventListener("error", handleError);
  });

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    el?.addEventListener("error", handleError);

    return () => {
      // eslint-disable-next-line no-unused-expressions
      el?.removeEventListener("error", handleError);
    };
  }, [el]);

  /**
   * In case of SSR, error can happen before hydration, and it is already too late to add
   * error handlers. So we check if image is there after hydration and apply fallback
   * if it wasn't loaded. We also apply this style trick for Safari described above.
   */
  useEffect(() => {
    if (el) {
      const { complete, naturalHeight } = el;
      const errorLoadingImgBeforeHydration = complete && naturalHeight === 0;

      if (errorLoadingImgBeforeHydration) {
        el.src = defaultImage;

        el.style.display = "none";
        // eslint-disable-next-line no-unused-expressions
        el.offsetHeight;
        el.style.display = "block";
      }
    }
  }, [el]);

  return [setEl];
};

export default useImageErrorFallback;
